/**
 * Quick shop on demand.
 *
 * Product tiles render an empty `.quick-shop` shell (`snippets/quick-shop-placeholder.liquid`)
 * instead of the full quick shop block, which made up about 40% of a collection
 * page's HTML and most of its DOM. The block (`sections/quick-shop-item.liquid`)
 * is fetched when a pointer reaches a tile's "Quick shop" button. A click that
 * arrives before it is in place is stopped before the vendor handler sees it,
 * and the button is clicked again once the block is in the shell, so the vendor
 * handler finds the form it expects.
 *
 * The vendor tile script keeps references to the shell and to its
 * `[data-quantity-error]` element, so both are reused instead of replaced.
 * If the fetch fails, a click sends the visitor to the product page.
 */
(function () {
  if (window.__skuQuickShopOnDemand) return;
  window.__skuQuickShopOnDemand = true;

  var BUTTON = '.product-tile__quick-shop-button';
  var requests = new WeakMap();

  function shellFor(button) {
    var tile = button.closest('[data-product-tile]');
    return tile && tile.querySelector('.quick-shop[data-quick-shop-url]');
  }

  function fill(shell, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var content = doc.querySelector('[data-quick-shop-item]');
    if (!content || !content.querySelector('form')) throw new Error('Quick shop markup missing');

    var quantityError = shell.querySelector('[data-quantity-error]');
    var fetchedError = content.querySelector('[data-quantity-error]');
    if (quantityError && fetchedError) fetchedError.parentNode.replaceChild(quantityError, fetchedError);

    while (shell.firstChild) shell.removeChild(shell.firstChild);
    while (content.firstChild) shell.appendChild(document.adoptNode(content.firstChild));
    shell.removeAttribute('data-quick-shop-url');
  }

  function load(shell) {
    if (!requests.has(shell)) {
      var url = shell.getAttribute('data-quick-shop-url');
      var request = fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=quick-shop-item', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Quick shop request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          fill(shell, html);
        });
      request.catch(function () {
        requests.delete(shell);
      });
      requests.set(shell, request);
    }
    return requests.get(shell);
  }

  function prefetch(event) {
    var button = event.target.closest && event.target.closest(BUTTON);
    var shell = button && shellFor(button);
    if (shell) load(shell).catch(function () {});
  }

  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest(BUTTON);
      var shell = button && shellFor(button);
      if (!shell) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.getAttribute('aria-busy') === 'true') return;

      var url = shell.getAttribute('data-quick-shop-url');
      button.setAttribute('aria-busy', 'true');
      load(shell)
        .then(function () {
          button.removeAttribute('aria-busy');
          button.click();
        })
        .catch(function (error) {
          button.removeAttribute('aria-busy');
          console.error(error);
          window.location.href = url;
        });
    },
    true
  );
})();
